import React from "react";
import { pure } from "recompose";
import { flatten, map } from "lodash";
import { Link } from "react-router";

const divStyle = {
  marginTop: "1em",
  marginBottom: "1em"
};

const linkStyle = {
  fontSize: "12px",
  fontFamily: "Lato",
  color: "#828282"
};

const separatorStyle = {
  marginLeft: "1ch",
  marginRight: "1ch",
  fontSize: "12px",
  fontFamily: "Lato",
  color: "#828282"
};

const bStyle = {
  fontSize: "12px",
  fontFamily: "Lato",
  color: "#222222"
};

export default pure(({ crumbs }) => (
  <div style={divStyle}>
    {flatten(
      map(crumbs, ({ location, label }, index) => [
        index !== 0 ? (
          <span key={`${location}:${label}-sep`} style={separatorStyle}>
            >
          </span>
        ) : null,
        location ? (
          <Link
            to={location}
            style={linkStyle}
            key={`${location}:${label}`}
          >
            {label}
          </Link>
        ) : (
          <b key={`${location}:${label}`} style={bStyle}>
            {label}
          </b>
        )
      ])
    )}
  </div>
));



// WEBPACK FOOTER //
// ./src/components/bcase/BreadCrumbs.js